import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { FilterContext } from 'context/Context';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ServiceGroupService from 'services/ServiceGroup.service';
import TableRow from '../../dashboards/support-desk/TableRow';
import TicketsByServiceGroupChart from './TicketsByServiceGroupChart';

const TicketsByServiceGroup = ({ data, filtersDash }) => {
  const { setFilters } = useContext(FilterContext);
  const navigate = useNavigate();
  const [serviceGroups, setServiceGroups] = useState([]);

  useEffect(() => {
    const fetchServiceGroups = async () => {
      try {
        const response = await ServiceGroupService.listSummaryData('size=1000');
        if (response.content) {
          setServiceGroups(response.content);
        }
      } catch (error) {
        console.error('Error fetching service groups', error);
      }
    };
    fetchServiceGroups();
  }, []);

  const processFilterArray = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value.map(v => {
        const parsed = parseInt(v, 10);
        return isNaN(parsed) ? v : parsed;
      });
    }
    return value || '';
  };

  const handleChartClick = params => {
    const { name } = params;
    const group = serviceGroups.find(
      sg => sg.name.trim().toLowerCase() === name.trim().toLowerCase()
    );

    if (group) {
      setFilters({
        page: 0,
        size: 20,
        code: '',
        priorities: filtersDash.priority || '',
        status: ['TO_DO', 'IN_PROGRESS', 'PENDING'],
        customer: processFilterArray(filtersDash.customer),
        serviceCatalog: '',
        category: '',
        subcategory: '',
        subject: '',
        agent: processFilterArray(filtersDash.agent),
        serviceGroup: [group.id],
        typeTicket: '',
        initialCreationDate: filtersDash.initialCreationDate || '',
        endCreationDate: filtersDash.endCreationDate || '',
        initialSolutionDate: '',
        endSolutionDate: '',
        statusSlaResponse: '',
        statusSlaSolution: '',
        createdBy: '',
        defaultFilter: ''
      });
      navigate('/tickets');
    } else {
      console.warn('Service Group not found for name:', name);
    }
  };

  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Tickets em Aberto por Grupo de Serviço"
        titleTag="h4"
        className="py-2"
      />
      <Card.Body as={Flex} alignItems="center" className="p-3">
        <Row className="w-100">
          <Col lg={12} xs={12}>
            <TicketsByServiceGroupChart
              data={data}
              onClick={handleChartClick}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

TicketsByServiceGroup.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(TableRow.propTypes.data)).isRequired
};

export default TicketsByServiceGroup;
